const shuffleArray = (array, protectedIndex = 0) => {
  const shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > protectedIndex - 1; i--) {
    const j = Math.floor(
      Math.random() * (shuffledArray.length - 1 - protectedIndex)
    ) + protectedIndex;
    const temp = shuffledArray[i];
    shuffledArray[i] = shuffledArray[j];
    shuffledArray[j] = temp;
  }
  return shuffledArray;
};
export {
  shuffleArray
};
